module.exports = __webpack_public_path__ + "src/img/echarts.19b18ca0316f496a321e9b9f6b7dd917.png";